import type React from "react"
import { memo } from "react"
import { twMerge } from "tailwind-merge"

type TagsProps = {
  variant: "success" | "warning" | "danger" | "optional"
  label: string
}

const Tags: React.FC<TagsProps> = ({ variant = "success", label }) => {
  const variantColorClasses = {
    success: "bg-pn_green-500 text-pn_white",
    warning: "bg-pn_orange-500 text-pn_white",
    danger: "bg-pn_red-500 text-pn_white",
    optional: "bg-pn_gray-300 text-pn_gray-950",
  }

  return (
    <div
      className={twMerge(
        variantColorClasses[variant],
        "rounded-[4px] px-2 font-semibold text-[11px] leading-[22px] uppercase",
      )}
    >
      {label}
    </div>
  )
}
export default memo(Tags)
